<template>
  <div id="video">
    <header-el></header-el>
    <div class="mb20">
      <div class="search-container" style="width: 100%; height: 300px;">
        <div class="search-mask"></div>
        <img style="height: 300px;object-fit:cover;"  src="/images/run1.jpeg" />
        <div class="search-list">
          <div class="search-part">
            <input type="text" placeholder="搜索视频" autofocus="autofocus" class="search-input"
              v-model="searchKey"
              />
            <input type="submit" value="搜  索" class="search-btn" v-on:click="onSearch" />
          </div>
          <div class="hot-word">
            <span>热词搜索：</span>
            <!--<a href="javascript:;" v-on:click="filter.Title=null;loadProduct()">全部</a>-->
            <a href="javascript:;" v-on:click="searchbtnclick('篮球')">篮球</a>
            <a href="javascript:;" v-on:click="searchbtnclick('骑行')">骑行</a>
            <a href="javascript:;" v-on:click="searchbtnclick('跑步')">跑步</a>
          </div>
        </div>
      </div>
    </div>
    <div class="project-screen">
      <div class="screen-head" v-if="false">
        <ul class="screen-title">
          <li :class="globalConfig.selectedCategoryID==category.ID?'screen-active':''" v-for="category in categories" v-on:click="caregorchoose(category.ID)" v-bind:key="category.ID">{{category.Name}}</li>
        </ul>
        <div class="screen-button" style="display:none;">
          <div class="special-button">
            <div class style="width: 130px;">
              <div class="select-tab" :class="{'select-tab-click':globalConfig.statusIsShow}" v-on:click="selecttab1">
                <span>{{globalConfig.statusText}}</span>
                <span class="status-icon" :class="{'icon-kaistart-direction-up':globalConfig.statusIsShow,'icon-kaistart-direction-down':!globalConfig.statusIsShow}"></span>
              </div>
              <div class="option-tab" style="width: 130px; " v-show="globalConfig.statusIsShow">
                <ul>
                  <li :class="{'active':globalConfig.statusText=='待发布'}" v-on:click="sortselect1('待发布')">待发布</li>
                  <li :class="{'active':globalConfig.statusText=='进行中'}" v-on:click="sortselect1('进行中')">进行中</li>
                  <li :class="{'active':globalConfig.statusText=='已结束'}" v-on:click="sortselect1('已结束')">已结束</li>
                </ul>
              </div>
              <div data-v-042cdcc3="" :class="{'special-cover':globalConfig.sortText=='即将结束'}"></div>
            </div>
            <div class></div>
          </div>
          <div class="special-button">
            <div style="width: 130px;">
              <div class="select-tab" @click="selecttab2" :class="{'select-tab-click':globalConfig.sortIsShow}">
                <span>{{globalConfig.sortText}}</span>
                <span class="status-icon" :class="{'icon-kaistart-direction-up':globalConfig.sortIsShow,'icon-kaistart-direction-down':!globalConfig.sortIsShow}"></span>
              </div>
              <div class="option-tab" style="width: 130px;" v-show="globalConfig.sortIsShow">
                <ul>
                  <li :class="{'active':globalConfig.sortText=='最新上线'}" v-on:click="sortselect2('最新上线')">最新上线</li>
                  <li :class="{'active':globalConfig.sortText=='即将结束'}" v-on:click="sortselect2('即将结束')">即将结束</li>
                </ul>
              </div>
              <div data-v-042cdcc3="" :class="{'special-cover':globalConfig.statusText=='已结束'}"></div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <ul class="screen-list moreli">
        <videoBox v-for="video in videos" v-bind:key="video.ID" v-bind:video="video"></videoBox>
      </ul>
    </div>
    <!-- <div class="result-contaniner" v-if="!d_productScreenshow">
      <div class="result-title">
        <span>搜索结果</span>包含关键词
        <b v-text="d_searproductchval"></b> 的结果
        <b v-text="products.TotalCount"></b> 个
      </div>
      <div class="result-subtitle">
        <span class="result-subtitle-btn">商品</span>
      </div>
      <ul class="result-program">
        <productBox-el v-for="video in videos" v-bind:key="video.ID" v-bind:video="video"></productBox-el>
      </ul>
      <div class="nomore" v-show="videos.length==0">
        <p>没有更多视频了...</p>
      </div>
    </div> -->
    <footer-el></footer-el>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Header from "../components/header";
import Footer from "../components/footer";
import videoBox from "../components/videoBox";
export default {
  name: "video",
  components: {
    "header-el": Header,
    "footer-el": Footer,
    "videoBox":videoBox,
  },
  computed: {
    ...mapState({
      videos: state => state.news.videos,
    })
  },
  data() {
    return {
      searchKey:'',
      filter:{
        Content: { Value: null },
        Pager: { PageNumber: 1, PageSize: 20 },
      },
    };
  },
  methods: {
    onSearch:function(val) {
      this.filter.Content.Value=this.searchKey;
      this.loadVideos();
    },
    loadVideos: function() {
      this.$store.dispatch("news/getVideos", this.filter);
    },
  },
  watch: {
  },
  created: function() {
  },
  mounted: function() {
    this.loadVideos();
  }
}
</script>
<style>
@import url("../css/projectlist.css");
.screen-list{
  padding-bottom:20px;
}
footer{
  padding: 80px 0 0px;
}
</style>
